import * as React from 'react';
import { SVGProps } from 'react';

const PlansSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    viewBox='0 0 20 20'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      stroke='#A0A4A8'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M9.167 3.333H3.334A1.667 1.667 0 0 0 1.667 5v11.667a1.666 1.666 0 0 0 1.667 1.666H15a1.666 1.666 0 0 0 1.667-1.666v-5.834'
    />
    <path
      stroke='#A0A4A8'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M15.417 2.083a1.768 1.768 0 0 1 2.5 2.5L10 12.5l-3.333.833L7.5 10l7.917-7.917Z'
    />
  </svg>
);

export default PlansSidebar;
